import React, { useEffect, useMemo } from "react";
import { Box } from "@mui/material";

const defaultEmployeeCategoryData = [
  {
    EmployeeCategory: "Executive Management",
    Women: "",
    Men: "",
    Others: "",
    NotDisclosed: "",
  },
  {
    EmployeeCategory: "Non-Executive Management",
    Women: "",
    Men: "",
    Others: "",
    NotDisclosed: "",
  },
  {
    EmployeeCategory: "Professionals",
    Women: "",
    Men: "",
    Others: "",
    NotDisclosed: "",
  },
  {
    EmployeeCategory: "All Other Employees",
    Women: "",
    Men: "",
    Others: "",
    NotDisclosed: "",
  },
];

const EmployeeCategoryTable = ({
  employeeCategoryTable,
  setEmployeeCategoryTable,
}) => {
  const tableData = useMemo(() => {
    if (
      Array.isArray(employeeCategoryTable) &&
      employeeCategoryTable.length === 4
    ) {
      return employeeCategoryTable;
    }
    return defaultEmployeeCategoryData;
  }, [employeeCategoryTable]);

  useEffect(() => {
    if (!employeeCategoryTable || employeeCategoryTable.length === 0) {
      setEmployeeCategoryTable(defaultEmployeeCategoryData);
    }
  }, [employeeCategoryTable, setEmployeeCategoryTable]);

  const handleInputChange = (rowIndex, field, value) => {
    const updatedData = [...tableData];
    updatedData[rowIndex][field] = value;
    setEmployeeCategoryTable(updatedData);
  };

  return (
    <div
      style={{
        marginTop: "20px",
        border: "1px solid #000",
        borderRadius: "8px",
        overflow: "hidden",
        width: "100%",
      }}
    >
      <Box sx={{ width: "100%" }}>
        <table
          style={{
            minWidth: "800px",
            width: "100%",
            borderCollapse: "collapse",
          }}
        >
          <thead>
            <tr
              style={{
                backgroundColor: "#D3C9CE",
                color: "#000",
                fontWeight: "bold",
              }}
            >
              <th style={tableHeaderStyle}>Employee Category</th>
              <th style={tableHeaderStyle}>Women (%)</th>
              <th style={tableHeaderStyle}>Men (%)</th>
              <th style={tableHeaderStyle}>Others (%)</th>
              <th style={tableHeaderStyle}>Not Disclosed (%)</th>
            </tr>
          </thead>
          <tbody>
            {tableData.map((row, index) => (
              <tr key={index}>
                <td
                  style={{
                    ...tableCellStyle,
                    backgroundColor: "#f5f5f5",
                    fontWeight: "bold",
                  }}
                >
                  {row.EmployeeCategory}
                </td>
                {["Women", "Men", "Others", "NotDisclosed"].map((field) => (
                  <td key={field} style={tableCellStyle}>
                    <input
                      type="number"
                      value={row[field]}
                      onChange={(e) =>
                        handleInputChange(index, field, e.target.value)
                      }
                      style={inputFieldStyle}
                    />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </Box>
    </div>
  );
};

const tableHeaderStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const tableCellStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const inputFieldStyle = {
  width: "100%",
  padding: "6px",
  borderRadius: "4px",
  border: "1px solid grey",
  textAlign: "center",
  fontSize: "14px",
  backgroundColor: "white",
  outline: "none",
};

export default EmployeeCategoryTable;
